<mat-progress-bar
  mode="indeterminate"
  color="warn"
  [style.display]="loading ? 'block' : 'none'"
/>

<h2 class="m-4 nowrap">
  <span class="titulo">
    <span class="cursor-pointer" (click)="volver()"> Pórticos</span>
    >
    {{ title }}
  </span>
</h2>

<div class="table-container mat-elevation-z8 p-2">
  @if (formulario) {
    <form id="form" [formGroup]="formulario" autocomplete="off">
      <div
        class="row row-lt-md-column gap-gt-sm-3 justify-start align-center"
      >
        <mat-form-field>
          <mat-label>Nombre del Pórtico</mat-label>
          <input matInput formControlName="nombre" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Fecha de Colocación</mat-label>
          <input
            matInput
            [matDatepicker]="picker1"
            formControlName="fechaColocacion"
          />
          <mat-datepicker-toggle matSuffix [for]="picker1" />
          <mat-datepicker #picker1 />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Cliente</mat-label>
          <mat-select formControlName="idCliente">
            @for (c of clientes; track c) {
              <mat-option [value]="c._id">
                {{ c.nombre }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Marca de Cámara</mat-label>
          <input matInput formControlName="marcaCamara" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>Modelo de Cámara</mat-label>
          <input matInput formControlName="modeloCamara" />
        </mat-form-field>
      </div>
      <!-- Mapa -->
      @if (coordenadas) {
        <div
          class="justify-center align-center"
          style="margin: 0 auto; width: 60%; height: 20%"
        >
          <div
            class="column gap-15px flex-1"
            [style.padding]="'0 1em'"
          >
            <app-mapa-picker
              [coordenadas]="coordenadas"
              (coordenadasChange)="onCoordenadas($event)"
              [zoom]="12"
            />
          </div>
        </div>
      }
      <mat-divider />
      <div
        class="row row-lt-md-column gap-gt-sm-5 justify-start align-center"
      >
        <!-- Porticos -->
        <mat-label>Configuración</mat-label>
      </div>
      <!-- Imagen -->
      <div style="margin: 1em">
        <div
          class="row row-lt-md-column justify-start align-center gap-gt-sm-15px"
        >
          <mat-card-content>
            <mat-form-field>
              <mat-label>Cantidad de cámaras</mat-label>
              <mat-select formControlName="cantCamaras">
                @for (numero of numeros; track numero) {
                  <mat-option [value]="numero">
                    {{ numero }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </mat-card-content>
          <mat-form-field style="width: 60%">
            <mat-label>Tamaño imagen fondo</mat-label>
            <input matInput formControlName="tamFondo" />
          </mat-form-field>
          <!-- URL -->
          <mat-form-field>
            <mat-label>URL de la imagen de fondo</mat-label>
            <input matInput formControlName="imgFondo" />
          </mat-form-field>
          <!-- Muestra de la Imagen -->
          <img
            [src]="formulario.get('imgFondo')?.value"
            alt="Sin Imagen"
            height="100"
          />
        </div>
      </div>
      <div style="position: relative">
        <div class="subgrupo" formArrayName="configuraciones">
          <!-- <div class="subgrupo" [formGroup]="formularioConfig"> -->
          @for (numero of getPatentes(); track numero; let i = $index) {
            <div [formGroupName]="i">
              <div class="subgrupo">
                <div
                  class="row row-lt-md-column gap-gt-sm-5 justify-start align-center"
                >
                  <!-- Porticos -->
                  <mat-label>Configuración cámara {{ numero }} </mat-label>
                </div>
                <div
                  class="row row-lt-md-column gap-gt-sm-3 justify-start align-center"
                >
                  <mat-divider />
                  <mat-form-field>
                    <mat-label>Número Cámara</mat-label>
                    <input
                      matInput
                      formControlName="numeroCamara"
                      type="text"
                      pattern="^[0-9]*$"
                    />
                    @if (
                      configuraciones
                        .at(i)
                        .get("numeroCamara")
                        ?.hasError("required") &&
                      configuraciones.at(i).get("numeroCamara")?.touched
                    ) {
                      <mat-error> Campo Requerido </mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Tamaño de la Patente</mat-label>
                    <input
                      matInput
                      formControlName="tamP"
                      type="text"
                      pattern="^[0-9]*$"
                    />
                    @if (
                      configuraciones.at(i).get("tamP")?.hasError("required") &&
                      configuraciones.at(i).get("tamP")?.touched
                    ) {
                      <mat-error> Campo Requerido </mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Distancia Vertical de la Patente</mat-label>
                    <input
                      matInput
                      formControlName="disSupP"
                      type="text"
                      pattern="^[0-9]*$"
                    />
                    @if (
                      configuraciones
                        .at(i)
                        .get("disSupP")
                        ?.hasError("required") &&
                      configuraciones.at(i).get("disSupP")?.touched
                    ) {
                      <mat-error> Campo Requerido </mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Distancia Horizontal de la Patente</mat-label>
                    <input
                      matInput
                      formControlName="disIzqP"
                      type="text"
                      pattern="^[0-9]*$"
                    />
                    @if (
                      configuraciones
                        .at(i)
                        .get("disIzqP")
                        ?.hasError("required") &&
                      configuraciones.at(i).get("disIzqP")?.touched
                    ) {
                      <mat-error> Campo Requerido </mat-error>
                    }
                  </mat-form-field>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
      <div
        class="row row-lt-md-column gap-gt-sm-5 justify-start align-center"
      >
        <div class="row justify-end gap-10px">
          <button
            class="porticoSpinner"
            mat-raised-button
            color="primary"
            type="submit"
            form="form"
            (click)="enviar()"
          >
            <div
              class="loadSpinnerButton"
              [style.display]="loading ? 'flex' : 'none'"
            >
              <mat-spinner
                class="mx-2"
                [diameter]="25"
                mode="indeterminate"
                color="warn"
              />
            </div>
            <div [style.display]="loading ? 'none' : 'flex'">Guardar</div>
          </button>
          <button mat-raised-button type="button" (click)="volver()">
            Volver
          </button>
        </div>
      </div>
    </form>
  }
</div>
